import { BlockListSection, DetailSection, Section } from '@sr/types';
import equal from 'fast-deep-equal/es6/react';
import * as React from 'react';
import { Box, Button, TrashIcon } from '../../ui';
import API from '../../utils/api';

type Props = {
  itemId: string;
  section: DetailSection | BlockListSection;
  children: React.ReactNode;
};

const ItemFormContainer = ({ itemId, section, children }: Props) => (
  <Box
    id={`nav-${itemId}`}
    sx={{
      position: 'relative',
      mb: 5,
      ':focus-within button.deleteItem': {
        opacity: 0.5,
      },
      ':hover button.deleteItem': {
        opacity: 0.5,
      },
    }}
  >
    <DeleteButton itemId={itemId} section={section} />
    {children}
  </Box>
);

type DeleteProps = {
  itemId: string;
  section: DetailSection | BlockListSection;
};

const DeleteButton = React.memo<DeleteProps>(function DeleteButton({
  itemId,
  section,
}: DeleteProps) {
  return (
    <Button
      className="deleteItem gi-delete-item"
      onClick={() => handleDelete(section, itemId)}
      tabIndex={-1}
      data-testid="delete-item"
      sx={{
        zIndex: 2,
        variant: 'buttons.link',
        opacity: [1, 1, 0],
        position: 'absolute',
        top: '-3px',
        right: '4px',
        p: 3,
        transition: 'opacity 150ms linear',
        ':hover': {
          opacity: '1 !important',
        },
      }}
    >
      <TrashIcon color="black" size={24} />
    </Button>
  );
},
areEqual);

// Note: this is a fairly dangerous check because it could skip renders, but is expensive to render.
// The section is only used for sectionItem.delete, which only checks section.itemsOrder (excluding
// ids that don't change).
function areEqual(prevProps: DeleteProps, nextProps: DeleteProps): boolean {
  if (
    prevProps.itemId === nextProps.itemId &&
    equal(prevProps.section.itemsOrder, nextProps.section.itemsOrder)
  )
    return true;
  return false;
}

function handleDelete(
  section: BlockListSection | DetailSection,
  itemId: string
) {
  if (window.confirm('Are you sure that you want to delete this section?')) {
    API.sectionItem.delete({ section, sectionItemId: itemId });
  }
}

export default ItemFormContainer;
